import {
  zahlungsstatusLabel,
  zahlungsstatusBadgeClasses,
  klageStatusLabel,
  klageStatusBadgeClasses,
  wartenAufLabel,
} from '@/lib/akten-hauptphase';
import {
  stellungnahmeStatusLabel,
  stellungnahmeStatusChipClasses,
} from '@/lib/akten-stellungnahme';

interface AktenSubStatusBadgesProps {
  zahlungsstatus?: string | null;
  klage_status?: string | null;
  warten_auf?: string | null;
  stellungnahme_status?: string | null;
  betriebId?: string;
}

export function AktenSubStatusBadges({
  zahlungsstatus,
  klage_status,
  warten_auf,
  stellungnahme_status,
  betriebId,
}: AktenSubStatusBadgesProps) {
  const zahlungLabel  = zahlungsstatusLabel(zahlungsstatus);
  const zahlungClasses = zahlungsstatusBadgeClasses(zahlungsstatus);
  const klageLabel    = klageStatusLabel(klage_status);
  const klageClasses  = klageStatusBadgeClasses(klage_status);
  const wartenLabel   = wartenAufLabel(warten_auf);

  const showStellungnahme = betriebId === 'gutachten' || betriebId == null;
  const stnLabel   = showStellungnahme ? stellungnahmeStatusLabel(stellungnahme_status) : null;
  const stnClasses = showStellungnahme ? stellungnahmeStatusChipClasses(stellungnahme_status) : null;

  const hasAny = zahlungLabel || klageLabel || wartenLabel || stnLabel;
  if (!hasAny) return null;

  return (
    <div
      data-testid="akten-substatus-badges"
      className="flex items-center gap-1.5 flex-wrap"
    >
      {zahlungLabel && zahlungClasses && (
        <span
          data-testid="badge-zahlungsstatus"
          className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${zahlungClasses}`}
        >
          {zahlungLabel}
        </span>
      )}

      {stnLabel && stnClasses && (
        <span
          data-testid="badge-stellungnahme"
          className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${stnClasses}`}
        >
          Stellungnahme: {stnLabel}
        </span>
      )}

      {klageLabel && klageClasses && (
        <span
          data-testid="badge-klage-status"
          className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${klageClasses}`}
        >
          {klageLabel}
        </span>
      )}

      {wartenLabel && (
        <span
          data-testid="badge-warten-auf"
          className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 border border-gray-200"
        >
          {wartenLabel}
        </span>
      )}
    </div>
  );
}
